var config              = require("app/config"),
    get                 = require("object-path").get,
    highlightTypes      = get(config, "search.highlightTypes", ["page", "category"]),
    quickMacroize       = require("enyo/macroize").quickMacroize,
    transformAncestor,
    transformResult,
    transformMediaLinks = require("app/Domain/Ott/Api/V2/DataTransformers/transformMediaLinks");

/**
 * Takes raw incoming data from the API and applies some extra sugar.
 *
 * @param    {string}  language  The current application language
 * @param    {Array}   results   The results data
 * @param    {Object}  query     The search query
 * @param    {Array}   type      The requested content types
 * @returns  {Object}  The transformed data
 * @public
 */
exports.transformResults = function(language, results, query, type) {
    var splitResults = {
        highlights: [],
        main:       []
    };

    results = results || [];
    results
        .filter(function(result) {
            // Only supported types
            switch (result.type) {
                case "album_track":
                case "artist_page":
                case "audio":
                case "book":
                case "brand":
                case "category":
                case "episode":
                case "external":
                case "issue":
                case "magazine":
                case "music_album":
                case "page":
                case "photo":
                case "playlist_page":
                case "podcast":
                case "podcast_episode":
                case "product":
                case "product_category":
                case "series":
                case "video":
                    return true;
                default:
                    return false;
            }
        })
        .forEach(function(result) {
            // Transform result
            result = transformResult(language, query, type, result);

            // Move to highlights
            if (type === null
                && highlightTypes.includes(get(result, "type", null))
                && splitResults.highlights.length < config.maxCategoryLength) {
                splitResults.highlights.push(result);
            }

            // Keep in main result
            else {
                splitResults.main.push(result);
            }
        });

    return splitResults;
};

/**
 * Adds links to search result.
 *
 * @param    {string}  language  The current application language
 * @param    {string}  query     The search query
 * @param    {string}  type      The requested content types
 * @param    {Object}  result    The result data
 * @returns  {Object}  The transformed data
 * @private
 */
transformResult = function(language, query, type, result) {
    // Add links
    result = transformMediaLinks(language, result);

    // Add links
    switch (result.type) {
        case "album_track":
        case "audio":
        case "book":
        case "episode":
        case "issue":
        case "podcast_episode":
        case "video":
            result.links.details = quickMacroize("/{$language}/search/{$query}/{$mediaType}/{$mediaSlug}", {
                language:  language,
                query:     encodeURIComponent(query),
                mediaType: result.type.replaceAll("_", "-"),
                mediaSlug: get(result, "meta.slug", null)
            }) + "?" + new  URLSearchParams({
                type: type
            }).toString();
            break;
        case "artist_page":
        case "brand":
        case "category":
        case "external":
        case "magazine":
        case "music_album":
        case "page":
        case "photo":
        case "playlist_page":
        case "podcast":
        case "product":
        case "product_category":
        case "series":
        default:
            break;
    }

    if (result.parent && typeof result.parent === "object") {
        result.parent = transformAncestor(language, result.parent);
    }

    return result;
};

/**
 * Adds links to ancestor.
 *
 * @param    {string}  language  The current application language
 * @param    {Object}  media     The media data
 * @returns  {Object}  The transformed data
 * @public
 */
transformAncestor = function(language, media) {
    media = transformMediaLinks(language, media);

    if (media.parent && typeof media.parent === "object") {
        media.parent = transformAncestor(language, media.parent);
    }

    return media;
};
